<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vigne Marina Coppi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando il tuo nome è una leggenda (il padre di Marina, Fausto Coppi, è stato il primo uomo a vincere il Giro
                        d'Italia e il Tour de France nello stesso anno, così come il Giro d'Italia cinque volte, il
                        Tour di Francia due volte e Campionato del Mondo una volta tutti tra il 1940 e il 1953), poi sei
                        avrà bisogno che i tuoi vini siano buoni. Per fortuna, i vini pregiati di Marina Coppi sono buoni quanto lei
                        ciclismo del padre.
                    </div>

                    <div class="howto-title2">Un cognome di cui essere all'altezza</div>
                    <div class="howto-text">
                        Vigne Marini Coppi si trova a Castellania, piccolo paese dei Colli Tortonesi
                        Piemonte. Fausto, l'originario proprietario del terreno, purtroppo morì prima di poterlo sfruttare
                        a qualsiasi uso commerciale, quindi toccò al nipote Francesco trasformare il terreno di 4,5 ettari di
                        atterrare in qualcosa di cui vale la pena scrivere. Dopo aver studiato enologia in xxx, lui (e sua moglie
                        Anna) ha fondato Vigne Marina Coppi nel 2003, onorando sia sua madre intitolandola a lei che
                        suo nonno, il cui nome è sul Timorasso. Il Fausto è il vino di punta di Marina Coppi e
                        gli investitori del fine wine italiano noteranno che mentre i prezzi sono rimasti stabili nel 2018, noi
                        sospetto che il valore di mercato aumenterà nel 2019-2020. Diversi critici hanno iniziato a ricevere
                        interessati al vino, con Wine Enthusiast che ha assegnato all'annata 2013 92 punti su 100.
                    </div>

                    <div class="howto-title2">Marina Coppi, Barbera e la Valle d'Asti</div>
                    <div class="howto-text">
                        Per capire Marina Coppi bisogna saper capire l'Astigiana.
                        A sud del Piemonte, qui prospera magnificamente l'uva Barbera; I collezionisti di vini pregiati italiani dovrebbero considerare la Barbera Sant'Andrea di Marina Coppi (90% Barbera, 10% Croatina), Barbera Castellania, Barbera Superiore I GROP come superbi esempi del fatto. La produzione del Superiore
                        deve soddisfare determinati requisiti minimi tra cui un livello alcolico più elevato (13%) e più a lungo
                        affinamento (minimo 14 mesi di cui 6 mesi in botte). La Barbera Superior rappresenta ancora
                        fantastico rapporto qualità-prezzo a circa € 25-30 a bottiglia sulla base dei prezzi del secondo trimestre 2019, in particolare perché
                        ha ricevuto più premi di qualsiasi altro vino della regione.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Vigne Marina Coppi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Ihr Name eine Legende ist (Marinas Vater Fausto Coppi war der erste Mann überhaupt, der den Giro gewann
                        d'Italia und der Tour de France im selben Jahr sowie fünfmal den Giro d'Italia
                        Zweimal Frankreich-Rundfahrt und einmal die Weltmeisterschaft zwischen 1940 und 1953), dann sind Sie es
                        Ihre Weine müssen gut sein. Zum Glück sind die erlesenen Weine von Marina Coppi genauso gut wie sie
                        Vaters Radfahren.
                    </div>

                    <div class="howto-title2">Ein Familienname, dem man alle Ehre machen kann</div>
                    <div class="howto-text">
                        Vigne Marini Coppi liegt in Castellania, einem kleinen Dorf in der Region Colli Tortonesi
                        Piemont. Fausto, der ursprüngliche Besitzer des Landes, starb leider, bevor er etwas davon ausbeuten konnte
                        Da das Grundstück nicht kommerziell genutzt werden konnte, oblag es seinem Enkel Francesco, das 4,5 Hektar große Grundstück umzuwandeln
                        Landen Sie in etwas, über das es sich zu schreiben lohnt. Nachdem er im Jahr 2000 Weinbau studiert hatte, gründeten er (und seine Frau)
                        Anna) gründete Vigne Marina Coppi im Jahr 2003 und ehrte sowohl seine Mutter, indem sie es nach ihr benannte, als auch
                        sein Großvater, dessen Name auf dem Timorasso steht. Der Fausto ist Marina Coppis Flaggschiffwein und
                        Investoren von italienischen Edelweinen werden feststellen, dass die Preise im Jahr 2018 zwar stabil geblieben sind, wir
                        vermuten, dass der Marktwert in den Jahren 2019-2020 steigen wird. Mehrere Kritiker haben begonnen, zu bekommen
                        interessiert sich für den Wein, wobei Wine Enthusiast dem Jahrgang 2013 92 von 100 Punkten gibt.
                    </div>

                    <div class="howto-title2">Marina Coppi, Barbera und das Asti-Tal</div>
                    <div class="howto-text">
                        Um Marina Coppi zu verstehen, muss man das Weintal von Asti verstehen.
                        Südlich des Piemont gedeiht hier die Barbera-Traube wunderbar; Sammler edler italienischer Weine sollten Marina Coppis Barbera Sant’Andrea (90 % Barbera, 10 % Croatina), Barbera Castellania und Barbera Superiore I GROP als hervorragende Beispiele dafür betrachten. Die Produktion des Superiore
                        muss bestimmte Mindestanforderungen erfüllen, einschließlich eines höheren Alkoholgehalts (13 %) und länger
                        Reifung (mindestens 14 Monate, davon 6 Monate im Fass). Barbera Superior repräsentiert immer noch
                        Ein fantastisches Preis-Leistungs-Verhältnis von etwa 25 bis 30 € pro Flasche, basierend auf den Preisen des zweiten Quartals 2019, vor allem weil es so ist
                        hat mehr Auszeichnungen erhalten als jeder andere Wein aus der Region.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vigne Marina Coppi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quand ton nom est une légende (le père de Marina, Fausto Coppi, a été le premier homme à remporter le Giro
                        d'Italia et le Tour de France la même année, ainsi que cinq fois le Giro d'Italia, le
                        Tour de France deux fois, et le championnat du monde une fois entre 1940 et 1953), alors vous êtes
                        va avoir besoin de vos vins pour être bon. Heureusement, les vins fins de Marina Coppi sont aussi bons qu'elle
                        le vélo du père.
                    </div>

                    <div class="howto-title2">Un nom de famille à la hauteur</div>
                    <div class="howto-text">
                        Vigne Marini Coppi se trouve à Castellania, un petit village de la région des Colli Tortonesi de
                        Piémont. Fausto, le propriétaire d'origine de la terre, est malheureusement décédé avant d'avoir pu exploiter quoi que ce soit
                        à tout usage commercial, il incombait donc à son petit-fils Francesco de transformer le terrain de 4,5 hectares de
                        atterrir dans quelque chose qui vaut la peine d'être écrit. Après des études de vinification en xxx, il (et sa femme
                        Anna) a fondé Vigne Marina Coppi en 2003, honorant à la fois sa mère en lui donnant son nom et
                        son grand-père, dont le nom est sur le Timorasso. Le Fausto est le vin phare de Marina Coppi et
                        les investisseurs de vins fins italiens noteront que si les prix sont restés stables en 2018, nous
                        soupçonnent que la valeur marchande augmentera en 2019-2020. Plusieurs critiques ont commencé à obtenir
                        intéressés par le vin, Wine Enthusiast donnant au millésime 2013 92 points sur 100.
                    </div>

                    <div class="howto-title2">Marina Coppi, Barbera et la vallée d'Asti</div>
                    <div class="howto-text">
                        Pour comprendre Marina Coppi, il faut comprendre la vallée viticole d'Asti.
                        Au sud du Piémont, le cépage Barbera prospère magnifiquement ici; Les collectionneurs de vins fins italiens devraient considérer le Barbera Sant 'Andrea de Marina Coppi (90% Barbera, 10% Croatina), Barbera Castellania, Barbera Superiore I GROP comme de superbes exemples de ce fait. La production de la Superiore
                        doit répondre à certaines exigences minimales, notamment un taux d'alcool plus élevé (13%) et plus
                        élevage (minimum 14 mois dont 6 mois en barrique). Barbera Superior représente toujours
                        rapport qualité-prix fantastique à environ 25-30 € la bouteille sur la base des prix du deuxième trimestre 2019, notamment car il
                        a reçu plus de prix que tout autre vin de la région.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Vigne Marina Coppi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When your name is a legend (Marina’s father Fausto Coppi was the first man ever to win the Giro
                        d'Italia and the Tour de France in the same year, as well as the Giro d’Italia five times, the
                        Tour of France twice, and the World Championship once all between 1940 and 1953), then you’re
                        going to need your wines to be good. Thankfully, Marina Coppi’s fine wines are as good as her
                        father’s cycling.
                    </div>

                    <div class="howto-title2">A family name to live up to</div>
                    <div class="howto-text">
                        Vigne Marini Coppi lies in Castellania, a small village in the Colli Tortonesi region of
                        Piedmont. Fausto, the original owner of the land, sadly died before he could exploit any of it
                        to any commercial usage, thus it fell to his grandson Francesco to turn the 4.5-hectare plot of
                        land into something worth writing about. After studying winemaking in xxx, he (and his wife
                        Anna) founded Vigne Marina Coppi in 2003, honouring both his mother by naming it after her and
                        his grandfather, whose name is on the Timorasso. The Fausto is Marina Coppi’s flagship wine and
                        investors of Italian fine wine will note that whiles prices have remained stable in 2018, we
                        suspect that the market value will increase in 2019-2020. Several critics have begun to get
                        interested in the wine, with Wine Enthusiast giving the 2013 vintage 92 points out of 100.
                    </div>

                    <div class="howto-title2">Marina Coppi, Barbera and the Asti Valley</div>
                    <div class="howto-text">
                        In order to understand Marina Coppi one needs to be able to understand the Asti wine valley.
                        South of Piedmont, the Barbera grape thrives beautifully here; Italian fine wine collectors should consider Marina Coppi’s Barbera Sant’ Andrea (90% Barbera, 10% Croatina), Barbera Castellania, Barbera Superiore I GROP as superb examples of the fact. The Superiore’s production
                        needs to meet certain minimum requirements including a higher alcohol level (13%) and longer
                        ageing (minimum 14 months including 6 months in barrel). Barbera Superior still represents
                        fantastic value for money at around €25-30 a bottle based on Q2 2019 prices, most notably as it
                        has received more awards than any other wine from the region.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VigneMarinaCoppi",
    head: {
        title: 'Vigne Marina Coppi | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Vigne Marina Coppi, a renowned wine producer in the Piedmont region. Experience the rich flavor and complexity of their premium wines made with expert craftsmanship.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
